import { format, isValid, parse } from 'date-fns';

export function parseDateValue(value?: string | null): Date | null {
  if (!value) return null;
  const parsed = parse(value, 'yyyy-MM-dd', new Date());
  return isValid(parsed) ? parsed : null;
}

export function formatDateValue(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function parseDateTimeLocal(value?: string | null): Date | null {
  if (!value) return null;
  const parsed = parse(value, "yyyy-MM-dd'T'HH:mm", new Date());
  return isValid(parsed) ? parsed : null;
}

export function formatDateTimeLocal(date: Date): string {
  return format(date, "yyyy-MM-dd'T'HH:mm");
}

export function displayDate(value?: string | null): string {
  const date = parseDateValue(value);
  return date ? format(date, 'MMM d, yyyy') : '';
}

export function displayDateTime(value?: string | null): string {
  const date = parseDateTimeLocal(value);
  return date ? format(date, 'MMM d, yyyy · HH:mm') : '';
}

/** Parse 24h time string `HH:mm` or `HH:mm:ss`. */
export function parseTimeValue(value?: string | null): { hour: number; minute: number } | null {
  if (!value) return null;
  const match = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(value.trim());
  if (!match) return null;
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
  return { hour, minute };
}

export function formatTimeValue(hour: number, minute: number): string {
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}

export function displayTime(value?: string | null): string {
  const parsed = parseTimeValue(value);
  if (!parsed) return '';
  return formatTimeValue(parsed.hour, parsed.minute);
}
